var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2a1 1 0 110-2h6a1 1 0 110 2h-6zM3.982 3.507L1.79 5.694a1.05 1.05 0 01-1.483 0 1.043 1.043 0 010-1.478L4.231.302A1.04 1.04 0 015 0c.278-.007.558.09.77.302l3.923 3.914c.41.408.41 1.07 0 1.478a1.05 1.05 0 01-1.483 0L5.982 3.47V13a1 1 0 11-2 0V3.507zM12 5a1 1 0 001 1h3a1 1 0 100-2h-3a1 1 0 00-1 1zM13 10a1 1 0 110-2h1a1 1 0 110 2h-1z",
    fill: "#42ABE9"
  })));
}
export default SvgAsc;